import * as Types from '../../__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMyUnreadCountVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyUnreadCount = { __typename?: 'Query', getMyUnreadCount: number };


export const GetMyUnreadCountDocument = gql`
    query GetMyUnreadCount {
  getMyUnreadCount
}
    `;

/**
 * __useGetMyUnreadCount__
 *
 * To run a query within a React component, call `useGetMyUnreadCount` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUnreadCount` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUnreadCount({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUnreadCount(baseOptions?: Apollo.QueryHookOptions<GetMyUnreadCount, GetMyUnreadCountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUnreadCount, GetMyUnreadCountVariables>(GetMyUnreadCountDocument, options);
      }
export function useGetMyUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUnreadCount, GetMyUnreadCountVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUnreadCount, GetMyUnreadCountVariables>(GetMyUnreadCountDocument, options);
        }
// @ts-ignore
export function useGetMyUnreadCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyUnreadCount, GetMyUnreadCountVariables>): Apollo.UseSuspenseQueryResult<GetMyUnreadCount, GetMyUnreadCountVariables>;
export function useGetMyUnreadCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyUnreadCount, GetMyUnreadCountVariables>): Apollo.UseSuspenseQueryResult<GetMyUnreadCount | undefined, GetMyUnreadCountVariables>;
export function useGetMyUnreadCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyUnreadCount, GetMyUnreadCountVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyUnreadCount, GetMyUnreadCountVariables>(GetMyUnreadCountDocument, options);
        }
export type GetMyUnreadCountHookResult = ReturnType<typeof useGetMyUnreadCount>;
export type GetMyUnreadCountLazyQueryHookResult = ReturnType<typeof useGetMyUnreadCountLazyQuery>;
export type GetMyUnreadCountSuspenseQueryHookResult = ReturnType<typeof useGetMyUnreadCountSuspenseQuery>;
export type GetMyUnreadCountQueryResult = Apollo.QueryResult<GetMyUnreadCount, GetMyUnreadCountVariables>;